import React from "react";

const EicIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.8398 2.04618C14.8485 2.26916 16.6863 3.28096 17.949 4.859C19.0301 6.21099 19.6187 7.89079 19.6178 9.62188C19.6169 11.353 19.0266 13.0322 17.944 14.383C17.8071 14.5545 17.6186 14.7489 17.4099 14.9641C16.8214 15.5711 16.0719 16.344 15.863 17.238H8.13203C7.92249 16.3406 7.16855 15.5638 6.57856 14.9559C6.37173 14.7428 6.18505 14.5505 6.04903 14.381C4.78633 12.803 4.20223 10.788 4.42521 8.77925C4.64819 6.77055 5.65999 4.9327 7.23803 3.67C8.81607 2.40731 10.8311 1.8232 12.8398 2.04618Z"
      fill="#FAFAFA"
    />
    <path
      d="M8.75218 21.4452C8.3942 21.0889 8.19236 20.6051 8.19104 20.1V19.148H15.81V20.1C15.8087 20.6037 15.608 21.0863 15.2517 21.4424C14.8955 21.7985 14.4127 21.9989 13.909 22H10.1C9.59498 22.0011 9.11016 21.8015 8.75218 21.4452Z"
      fill="#FAFAFA"
    />
  </svg>
);

const EvidenceSuiteIcon = () => (
  <svg
    width="160"
    height="40"
    viewBox="0 0 160 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="160" height="40" fill="#EC7200" fill-opacity="0.9" />
    <path
      d="M22.0117 25H17.0781V16.4336H22.0117V17.9219H18.8945V19.8027H21.7949V21.291H18.8945V23.5H22.0117V25ZM33.0254 16.4336L30.1133 25H28.1328L25.2266 16.4336H27.0605L28.6719 21.5312C28.6992 21.6172 28.7441 21.7793 28.8066 22.0176C28.8691 22.252 28.9316 22.502 28.9941 22.7676C29.0605 23.0293 29.1055 23.2461 29.1289 23.418C29.1523 23.2461 29.1934 23.0293 29.252 22.7676C29.3145 22.5059 29.375 22.2578 29.4336 22.0234C29.4961 21.7852 29.541 21.6211 29.5684 21.5312L31.1914 16.4336H33.0254ZM36.6094 25V16.4336H38.4258V25H36.6094ZM50.1895 20.6348C50.1895 21.5996 50.0039 22.4062 49.6328 23.0547C49.2656 23.6992 48.7324 24.1855 48.0332 24.5137C47.334 24.8379 46.4922 25 45.5078 25H43.082V16.4336H45.7715C46.6699 16.4336 47.4492 16.5938 48.1094 16.9141C48.7695 17.2305 49.2812 17.7012 49.6445 18.3262C50.0078 18.9473 50.1895 19.7168 50.1895 20.6348ZM48.3027 20.6816C48.3027 20.0488 48.209 19.5293 48.0215 19.123C47.8379 18.7129 47.5645 18.4102 47.2012 18.2148C46.8418 18.0195 46.3965 17.9219 45.8652 17.9219H44.8984V23.5H45.6777C46.5645 23.5 47.2227 23.2637 47.6523 22.791C48.0859 22.3184 48.3027 21.6152 48.3027 20.6816ZM59.3984 25H54.4648V16.4336H59.3984V17.9219H56.2812V19.8027H59.1816V21.291H56.2812V23.5H59.3984V25ZM71.291 25H68.9824L65.2559 18.5195H65.2031C65.2188 18.7891 65.2324 19.0605 65.2441 19.334C65.2559 19.6074 65.2676 19.8809 65.2793 20.1543C65.291 20.4238 65.3027 20.6953 65.3145 20.9688V25H63.6914V16.4336H65.9824L69.7031 22.8496H69.7441C69.7363 22.584 69.7266 22.3203 69.7148 22.0586C69.7031 21.7969 69.6914 21.5352 69.6797 21.2734C69.6719 21.0117 69.6641 20.75 69.6562 20.4883V16.4336H71.291V25ZM79.5918 17.8223C79.2441 17.8223 78.9355 17.8906 78.666 18.0273C78.4004 18.1602 78.1758 18.3535 77.9922 18.6074C77.8125 18.8613 77.6758 19.168 77.582 19.5273C77.4883 19.8867 77.4414 20.291 77.4414 20.7402C77.4414 21.3457 77.5156 21.8633 77.6641 22.293C77.8164 22.7188 78.0508 23.0449 78.3672 23.2715C78.6836 23.4941 79.0918 23.6055 79.5918 23.6055C79.9395 23.6055 80.2871 23.5664 80.6348 23.4883C80.9863 23.4102 81.3672 23.2988 81.7773 23.1543V24.6777C81.3984 24.834 81.0254 24.9453 80.6582 25.0117C80.291 25.082 79.8789 25.1172 79.4219 25.1172C78.5391 25.1172 77.8125 24.9355 77.2422 24.5723C76.6758 24.2051 76.2559 23.6934 75.9824 23.0371C75.709 22.377 75.5723 21.6074 75.5723 20.7285C75.5723 20.0801 75.6602 19.4863 75.8359 18.9473C76.0117 18.4082 76.2695 17.9414 76.6094 17.5469C76.9492 17.1523 77.3691 16.8477 77.8691 16.6328C78.3691 16.418 78.9434 16.3105 79.5918 16.3105C80.0176 16.3105 80.4434 16.3652 80.8691 16.4746C81.2988 16.5801 81.709 16.7266 82.0996 16.9141L81.5137 18.3906C81.1934 18.2383 80.8711 18.1055 80.5469 17.9922C80.2227 17.8789 79.9043 17.8223 79.5918 17.8223ZM91.0391 25H86.1055V16.4336H91.0391V17.9219H87.9219V19.8027H90.8223V21.291H87.9219V23.5H91.0391V25ZM106.006 22.6211C106.006 23.1289 105.883 23.5703 105.637 23.9453C105.391 24.3203 105.031 24.6094 104.559 24.8125C104.09 25.0156 103.52 25.1172 102.848 25.1172C102.551 25.1172 102.26 25.0977 101.975 25.0586C101.693 25.0195 101.422 24.9629 101.16 24.8887C100.902 24.8105 100.656 24.7148 100.422 24.6016V22.9141C100.828 23.0938 101.25 23.2559 101.688 23.4004C102.125 23.5449 102.559 23.6172 102.988 23.6172C103.285 23.6172 103.523 23.5781 103.703 23.5C103.887 23.4219 104.02 23.3145 104.102 23.1777C104.184 23.041 104.225 22.8848 104.225 22.709C104.225 22.4941 104.152 22.3105 104.008 22.1582C103.863 22.0059 103.664 21.8633 103.41 21.7305C103.16 21.5977 102.877 21.4551 102.561 21.3027C102.361 21.209 102.145 21.0957 101.91 20.9629C101.676 20.8262 101.453 20.6602 101.242 20.4648C101.031 20.2695 100.857 20.0332 100.721 19.7559C100.588 19.4746 100.521 19.1387 100.521 18.748C100.521 18.2363 100.639 17.7988 100.873 17.4355C101.107 17.0723 101.441 16.7949 101.875 16.6035C102.312 16.4082 102.828 16.3105 103.422 16.3105C103.867 16.3105 104.291 16.3633 104.693 16.4688C105.1 16.5703 105.523 16.7188 105.965 16.9141L105.379 18.3262C104.984 18.166 104.631 18.043 104.318 17.957C104.006 17.8672 103.688 17.8223 103.363 17.8223C103.137 17.8223 102.943 17.8594 102.783 17.9336C102.623 18.0039 102.502 18.1055 102.42 18.2383C102.338 18.3672 102.297 18.5176 102.297 18.6895C102.297 18.8926 102.355 19.0645 102.473 19.2051C102.594 19.3418 102.773 19.4746 103.012 19.6035C103.254 19.7324 103.555 19.8828 103.914 20.0547C104.352 20.2617 104.725 20.4785 105.033 20.7051C105.346 20.9277 105.586 21.1914 105.754 21.4961C105.922 21.7969 106.006 22.1719 106.006 22.6211ZM117.031 16.4336V21.9766C117.031 22.5664 116.9 23.0996 116.639 23.5762C116.381 24.0488 115.988 24.4238 115.461 24.7012C114.938 24.9785 114.277 25.1172 113.48 25.1172C112.348 25.1172 111.484 24.8281 110.891 24.25C110.297 23.6719 110 22.9062 110 21.9531V16.4336H111.811V21.6777C111.811 22.3848 111.955 22.8809 112.244 23.166C112.533 23.4512 112.961 23.5938 113.527 23.5938C113.926 23.5938 114.248 23.5254 114.494 23.3887C114.744 23.252 114.928 23.041 115.045 22.7559C115.162 22.4707 115.221 22.1074 115.221 21.666V16.4336H117.031ZM121.629 25V16.4336H123.445V25H121.629ZM131.406 25H129.59V17.9453H127.264V16.4336H133.732V17.9453H131.406V25ZM142.484 25H137.551V16.4336H142.484V17.9219H139.367V19.8027H142.268V21.291H139.367V23.5H142.484V25Z"
      fill="white"
    />
  </svg>
);

const HomeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 8H20V5H4V8ZM14 19V10H10V19H14ZM16 19H20V10H16V19ZM8 19V10H4V19H8ZM3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3Z"
      fill="white"
    />
  </svg>
);

const ZaidynLogo = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5936_16502)">
      <path
        d="M45.6775 40.0352V19.78L41.5036 23.9648V44.22L45.6775 40.0352Z"
        fill="#C1C6C8"
      />
      <path
        d="M22.1746 40.0352V19.78L18 23.9648V44.22L22.1746 40.0352Z"
        fill="#98A4AE"
      />
      <path
        d="M23.8761 50.1096L28.0499 45.9256V34.1448L23.8761 38.3296V50.1096Z"
        fill="#EC7200"
      />
      <path
        d="M28.0499 13.8904L23.8761 18.0744V29.8552L28.0499 25.6704V13.8904Z"
        fill="#98A4AE"
      />
      <path
        d="M23.8761 29.8552V38.3296L28.0499 34.1448V25.6704L23.8761 29.8552Z"
        fill="#8D4900"
      />
      <path
        d="M29.7514 44.22V56L33.926 51.8152V40.0352L29.7514 44.22Z"
        fill="#C1C6C8"
      />
      <path
        d="M29.7514 32.4392V35.7448L33.926 31.5608V28.2552L29.7514 32.4392Z"
        fill="#EC7200"
      />
      <path
        d="M33.926 8L29.7514 12.1848V23.9648L33.926 19.78V8Z"
        fill="#98A4AE"
      />
      <path
        d="M29.7514 44.22L33.926 40.0352V31.5608L29.7514 35.7448V44.22Z"
        fill="#B35900"
      />
      <path
        d="M33.926 28.2552V19.78L29.7514 23.9648V32.4392L33.926 28.2552Z"
        fill="#8D4900"
      />
      <path
        d="M39.8021 34.1448L35.6275 38.3296V50.1096L39.8021 45.9256V34.1448Z"
        fill="#C1C6C8"
      />
      <path
        d="M39.8021 25.6704V13.8904L35.6275 18.0744V29.8552L39.8021 25.6704Z"
        fill="#EC7200"
      />
      <path
        d="M39.8021 25.6704L35.6275 29.8552V38.3296L39.8021 34.1448V25.6704Z"
        fill="#B35900"
      />
    </g>
    <defs>
      <clipPath id="clip0_5936_16502">
        <rect
          width="27.6774"
          height="48"
          fill="white"
          transform="translate(18 8)"
        />
      </clipPath>
    </defs>
  </svg>
);

const LibraryIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 11C13.3261 11 14.5979 11.5268 15.5355 12.4645L14.1827 13.9417C13.6578 13.385 12.9399 13.0499 12.176 13.005L12 13C11.2348 13 10.4985 13.2923 9.94174 13.8173C9.38499 14.3422 9.04989 15.0601 9.005 15.824L9 16V22H7V16C7 14.6739 7.52678 13.4021 8.46447 12.4645C9.40215 11.5268 10.6739 11 12 11ZM5.5 14C5.779 14 6.05 14.033 6.31 14.094C6.13902 14.603 6.03777 15.1328 6.009 15.669L6 16V16.086C5.88505 16.0449 5.76549 16.018 5.644 16.006L5.5 16C5.12712 16 4.76761 16.1389 4.49158 16.3896C4.21555 16.6403 4.0428 16.9848 4.007 17.356L4 17.5V22H2V17.5C2 16.5717 2.36875 15.6815 3.02513 15.0251C3.6815 14.3687 4.57174 14 5.5 14ZM5.5 8C6.16304 8 6.79893 8.26339 7.26777 8.73223C7.73661 9.20107 8 9.83696 8 10.5C8 11.163 7.73661 11.7989 7.26777 12.2678C6.79893 12.7366 6.16304 13 5.5 13C4.83696 13 4.20107 12.7366 3.73223 12.2678C3.26339 11.7989 3 11.163 3 10.5C3 9.83696 3.26339 9.20107 3.73223 8.73223C4.20107 8.26339 4.83696 8 5.5 8ZM5.5 10C5.36739 10 5.24021 10.0527 5.14645 10.1464C5.05268 10.2402 5 10.3674 5 10.5C5 10.6326 5.05268 10.7598 5.14645 10.8536C5.24021 10.9473 5.36739 11 5.5 11C5.63261 11 5.75979 10.9473 5.85355 10.8536C5.94732 10.7598 6 10.6326 6 10.5C6 10.3674 5.94732 10.2402 5.85355 10.1464C5.75979 10.0527 5.63261 10 5.5 10ZM12 2C13.0609 2 14.0783 2.42143 14.8284 3.17157C15.5786 3.92172 16 4.93913 16 6C16 7.06087 15.5786 8.07828 14.8284 8.82843C14.0783 9.57857 13.0609 10 12 10C10.9391 10 9.92172 9.57857 9.17157 8.82843C8.42143 8.07828 8 7.06087 8 6C8 4.93913 8.42143 3.92172 9.17157 3.17157C9.92172 2.42143 10.9391 2 12 2ZM12 4C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6C10 6.53043 10.2107 7.03914 10.5858 7.41421C10.9609 7.78929 11.4696 8 12 8C12.5304 8 13.0391 7.78929 13.4142 7.41421C13.7893 7.03914 14 6.53043 14 6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4Z"
      fill="white"
    />
    <path
      d="M14.595 18.812C14.4682 18.2784 14.4682 17.7226 14.595 17.189L13.603 16.616L14.603 14.884L15.595 15.457C15.9932 15.0799 16.4745 14.8017 17 14.645V13.5H19V14.645C19.532 14.803 20.012 15.085 20.405 15.457L21.397 14.884L22.397 16.616L21.405 17.189C21.5316 17.7223 21.5316 18.2777 21.405 18.811L22.397 19.384L21.397 21.116L20.405 20.543C20.0068 20.9201 19.5255 21.1983 19 21.355V22.5H17V21.355C16.4745 21.1983 15.9932 20.9201 15.595 20.543L14.603 21.116L13.603 19.384L14.595 18.812ZM18 19.5C18.3978 19.5 18.7794 19.342 19.0607 19.0607C19.342 18.7794 19.5 18.3978 19.5 18C19.5 17.6022 19.342 17.2206 19.0607 16.9393C18.7794 16.658 18.3978 16.5 18 16.5C17.6022 16.5 17.2206 16.658 16.9393 16.9393C16.658 17.2206 16.5 17.6022 16.5 18C16.5 18.3978 16.658 18.7794 16.9393 19.0607C17.2206 19.342 17.6022 19.5 18 19.5Z"
      fill="white"
    />
  </svg>
);

const ExploreIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.235 6.453C4.96004 7.77629 4.1795 9.49815 4.02457 11.3292C3.86964 13.1602 4.34977 14.9887 5.38426 16.5074C6.41874 18.0261 7.94451 19.1424 9.70511 19.6686C11.4657 20.1948 13.3538 20.0989 15.052 19.397C15.167 18.647 14.915 17.927 14.812 17.675C14.582 17.115 13.824 16.158 12.559 14.831C12.221 14.476 12.243 14.203 12.364 13.394L12.377 13.303C12.459 12.749 12.597 12.421 14.462 12.125C15.41 11.975 15.659 12.353 16.004 12.878L16.12 13.05C16.448 13.53 16.691 13.64 17.058 13.806C17.223 13.881 17.428 13.976 17.703 14.131C18.355 14.504 18.355 14.925 18.355 15.847V15.952C18.355 16.343 18.317 16.687 18.257 16.986C19.0244 16.0229 19.5591 14.8957 19.8196 13.6922C20.0801 12.4886 20.0593 11.2412 19.7588 10.047C19.4584 8.85284 18.8863 7.7441 18.0873 6.80714C17.2883 5.87017 16.2838 5.13026 15.152 4.645C14.599 5.018 13.84 5.547 13.575 5.91C13.44 6.095 13.248 7.042 12.625 7.12C12.463 7.14 12.244 7.126 12.012 7.111C11.39 7.071 10.54 7.016 10.268 7.755C10.095 8.223 10.065 9.495 10.624 10.155C10.714 10.26 10.731 10.455 10.67 10.674C10.59 10.961 10.429 11.136 10.378 11.172C10.282 11.116 10.09 10.893 9.959 10.742C9.646 10.377 9.254 9.922 8.748 9.782C8.564 9.731 8.362 9.689 8.165 9.647C7.616 9.532 6.995 9.401 6.85 9.093C6.744 8.867 6.745 8.556 6.745 8.228C6.745 7.811 6.745 7.34 6.541 6.883C6.47008 6.71991 6.36585 6.57344 6.235 6.453ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z"
      fill="white"
    />
  </svg>
);

const SurveyQuestionsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <path d="M9 6.39999H19V8.79999H9V6.39999Z" fill="white" />
    <path
      d="M7.4 7.59999C7.4 8.26274 6.86274 8.79999 6.2 8.79999C5.53726 8.79999 5 8.26274 5 7.59999C5 6.93725 5.53726 6.39999 6.2 6.39999C6.86274 6.39999 7.4 6.93725 7.4 7.59999Z"
      fill="white"
    />
    <path d="M9 10.8H19V13.2H9V10.8Z" fill="white" />
    <path
      d="M7.4 12C7.4 12.6627 6.86274 13.2 6.2 13.2C5.53726 13.2 5 12.6627 5 12C5 11.3373 5.53726 10.8 6.2 10.8C6.86274 10.8 7.4 11.3373 7.4 12Z"
      fill="white"
    />
    <path d="M9 15.2H19V17.6H9V15.2Z" fill="white" />
    <path
      d="M7.4 16.4C7.4 17.0627 6.86274 17.6 6.2 17.6C5.53726 17.6 5 17.0627 5 16.4C5 15.7373 5.53726 15.2 6.2 15.2C6.86274 15.2 7.4 15.7373 7.4 16.4Z"
      fill="white"
    />
  </svg>
);

const BespokeInsightIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.3186 6C10.6583 6 13.4159 8.50439 13.8328 11.7461L15.6806 14.6656C15.8023 14.8578 15.7777 15.1449 15.4959 15.2662L13.8872 15.9586V18.375C13.8872 19.2863 13.152 20.025 12.2451 20.025H10.6037L10.6029 22.5H3.21323L3.21343 19.4525C3.2135 18.4783 2.85484 17.5572 2.1914 16.7259C1.2895 15.5958 0.75 14.1612 0.75 12.6C0.75 8.95492 3.69086 6 7.3186 6ZM7.3186 7.65C4.5978 7.65 2.39215 9.86619 2.39215 12.6C2.39215 13.7425 2.77656 14.8216 3.47251 15.6937C4.37066 16.8191 4.85567 18.1004 4.85558 19.4527L4.85548 20.85H8.96133L8.96215 18.375H12.2451V14.8703L13.5175 14.3227L12.251 12.3217L12.2041 11.9575C11.8891 9.50741 9.80178 7.65 7.3186 7.65Z"
      fill="white"
    />
    <path
      clipRule="evenodd"
      d="M15.75 19.3637L17.1721 20.25C18.1689 18.855 18.75 17.1785 18.75 15.375C18.75 13.5715 18.1689 11.895 17.1721 10.5L15.75 11.3864C16.5655 12.5277 17.0409 13.8994 17.0409 15.375C17.0409 16.8506 16.5655 18.2223 15.75 19.3637Z"
      fill="white"
    />
    <path
      d="M19.8192 15.375C19.8192 14.6603 19.708 13.9684 19.5 13.3121L21.3263 12.75C21.6021 13.5828 21.75 14.4637 21.75 15.375C21.75 16.2863 21.6021 17.1672 21.3263 18L19.5 17.4379C19.708 16.7816 19.8192 16.0898 19.8192 15.375Z"
      fill="white"
    />
    <path
      d="M16.5489 3.70108L15.375 1.5L14.2011 3.70108L12 4.87499L14.2011 6.04892L15.375 8.25L16.5489 6.04892L18.75 4.87499L16.5489 3.70108Z"
      fill="white"
    />
    <path
      d="M19.5 6L20.2826 7.4674L21.75 8.24998L20.2826 9.0326L19.5 10.5L18.7174 9.0326L17.25 8.24998L18.7174 7.4674L19.5 6Z"
      fill="white"
    />
  </svg>
);

const SideNavQuestionMarkIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.9">
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11 15V17H13V15H11ZM13 13.355C13.8037 13.1128 14.4936 12.59 14.9442 11.8817C15.3947 11.1735 15.5759 10.3271 15.4547 9.49647C15.3336 8.66588 14.9181 7.90644 14.284 7.35646C13.6499 6.80647 12.8394 6.50254 12 6.5C11.1909 6.49994 10.4067 6.78015 9.78079 7.29299C9.15492 7.80583 8.72601 8.51963 8.567 9.313L10.529 9.706C10.5847 9.42743 10.7183 9.1704 10.9144 8.96482C11.1104 8.75923 11.3608 8.61354 11.6364 8.54471C11.912 8.47587 12.2015 8.48671 12.4712 8.57597C12.7409 8.66523 12.9797 8.82924 13.1598 9.04891C13.34 9.26858 13.454 9.53489 13.4887 9.81684C13.5234 10.0988 13.4773 10.3848 13.3558 10.6416C13.2343 10.8984 13.0423 11.1154 12.8023 11.2673C12.5623 11.4193 12.2841 11.5 12 11.5C11.7348 11.5 11.4804 11.6054 11.2929 11.7929C11.1054 11.9804 11 12.2348 11 12.5V14H13V13.355Z"
        fill="white"
      />
    </g>
  </svg>
);

const HeaderQuestionMarkIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.9">
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11 15V17H13V15H11ZM13 13.355C13.8037 13.1128 14.4936 12.59 14.9442 11.8817C15.3947 11.1735 15.5759 10.3271 15.4547 9.49647C15.3336 8.66588 14.9181 7.90644 14.284 7.35646C13.6499 6.80647 12.8394 6.50254 12 6.5C11.1909 6.49994 10.4067 6.78015 9.78079 7.29299C9.15492 7.80583 8.72601 8.51963 8.567 9.313L10.529 9.706C10.5847 9.42743 10.7183 9.1704 10.9144 8.96482C11.1104 8.75923 11.3608 8.61354 11.6364 8.54471C11.912 8.47587 12.2015 8.48671 12.4712 8.57597C12.7409 8.66523 12.9797 8.82924 13.1598 9.04891C13.34 9.26858 13.454 9.53489 13.4887 9.81684C13.5234 10.0988 13.4773 10.3848 13.3558 10.6416C13.2343 10.8984 13.0423 11.1154 12.8023 11.2673C12.5623 11.4193 12.2841 11.5 12 11.5C11.7348 11.5 11.4804 11.6054 11.2929 11.7929C11.1054 11.9804 11 12.2348 11 12.5V14H13V13.355Z"
        fill="#27A6A4"
      />
    </g>
  </svg>
);

const UserIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.9">
      <path
        d="M4 22C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14C14.1217 14 16.1566 14.8429 17.6569 16.3431C19.1571 17.8434 20 19.8783 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"
        fill="white"
      />
    </g>
  </svg>
);

const WindowIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.9">
      <path
        d="M3 3H11V11H3V3ZM3 13H11V21H3V13ZM13 3H21V11H13V3ZM13 13H21V21H13V13Z"
        fill="white"
      />
    </g>
  </svg>
);

const CopyIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.912 5.95198V2.92798C6.912 2.66064 7.01819 2.40426 7.20723 2.21522C7.39626 2.02618 7.65265 1.91998 7.91999 1.91998H20.016C20.2833 1.91998 20.5397 2.02618 20.7287 2.21522C20.9178 2.40426 21.024 2.66064 21.024 2.92798V17.04C21.024 17.3073 20.9178 17.5637 20.7287 17.7527C20.5397 17.9418 20.2833 18.048 20.016 18.048H16.992V21.072C16.992 21.6284 16.5384 22.08 15.9769 22.08H3.89505C3.76212 22.0808 3.63035 22.0553 3.5073 22.005C3.38425 21.9547 3.27235 21.8806 3.17803 21.7869C3.08371 21.6933 3.00881 21.5819 2.95767 21.4592C2.90652 21.3365 2.88013 21.2049 2.88 21.072L2.88303 6.95998C2.88303 6.40356 3.33662 5.95198 3.89808 5.95198H6.912ZM8.92799 5.95198H16.992V16.032H19.008V3.93598H8.92799V5.95198ZM6.912 10.992V13.008H12.96V10.992H6.912ZM6.912 15.024V17.04H12.96V15.024H6.912Z"
      fill="#716E79"
    />
  </svg>
);

const DeleteIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 4H22V6H20V21C20 21.2652 19.8946 21.5196 19.7071 21.7071C19.5196 21.8946 19.2652 22 19 22H5C4.73478 22 4.48043 21.8946 4.29289 21.7071C4.10536 21.5196 4 21.2652 4 21V6H2V4H7V2H17V4ZM9 9V17H11V9H9ZM13 9V17H15V9H13Z"
      fill="#716E79"
    />
  </svg>
);

const DeleteSmallIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.25 2V0.5H11.75V2H15.5V3.5H14V14.75C14 14.9489 13.921 15.1397 13.7803 15.2803C13.6397 15.421 13.4489 15.5 13.25 15.5H2.75C2.55109 15.5 2.36032 15.421 2.21967 15.2803C2.07902 15.1397 2 14.9489 2 14.75V3.5H0.5V2H4.25ZM3.5 3.5V14H12.5V3.5H3.5ZM5.75 5.75H7.25V11.75H5.75V5.75ZM8.75 5.75H10.25V11.75H8.75V5.75Z"
      fill="#454250"
    />
  </svg>
);

const DownloadIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 19H20V12H22V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V12H4V19ZM14 9H19L12 16L5 9H10V3H14V9Z"
      fill="#716E79"
    />
  </svg>
);

const EditIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.9 6.85802L17.142 11.101L7.242 21H3V16.757L12.9 6.85702V6.85802ZM14.314 5.44402L16.435 3.32202C16.6225 3.13455 16.8768 3.02924 17.142 3.02924C17.4072 3.02924 17.6615 3.13455 17.849 3.32202L20.678 6.15102C20.8655 6.33855 20.9708 6.59286 20.9708 6.85802C20.9708 7.12319 20.8655 7.37749 20.678 7.56502L18.556 9.68602L14.314 5.44402Z"
      fill="#716E79"
    />
  </svg>
);

const TableFilterIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5 13.5H10.5V12H7.5V13.5ZM2.25 4.5V6H15.75V4.5H2.25ZM4.5 9.75H13.5V8.25H4.5V9.75Z"
      fill="#B2B0B6"
    />
  </svg>
);

const ShareIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.576 17.271L8.466 14.484C7.97549 14.9709 7.35181 15.3017 6.67359 15.4346C5.99536 15.5676 5.29296 15.4968 4.65492 15.2311C4.01689 14.9654 3.47179 14.5168 3.08835 13.9418C2.70491 13.3668 2.50029 12.6911 2.50029 12C2.50029 11.3089 2.70491 10.6332 3.08835 10.0582C3.47179 9.48317 4.01689 9.03455 4.65492 8.76889C5.29296 8.50322 5.99536 8.43241 6.67359 8.56536C7.35181 8.69832 7.97549 9.02909 8.466 9.51599L13.576 6.72899C13.4007 5.90672 13.5273 5.04885 13.9326 4.31224C14.3379 3.57563 14.9947 3.00952 15.7831 2.71742C16.5715 2.42532 17.4386 2.42676 18.226 2.72147C19.0134 3.01619 19.6684 3.58448 20.0712 4.32243C20.474 5.06037 20.5978 5.91866 20.4198 6.74034C20.2418 7.56202 19.774 8.29218 19.1019 8.79729C18.4298 9.3024 17.5984 9.54871 16.7596 9.49119C15.9209 9.43366 15.1308 9.07613 14.534 8.48399L9.424 11.271C9.52593 11.7516 9.52593 12.2483 9.424 12.729L14.534 15.516C15.1308 14.9238 15.9209 14.5663 16.7596 14.5088C17.5984 14.4513 18.4298 14.6976 19.1019 15.2027C19.774 15.7078 20.2418 16.438 20.4198 17.2596C20.5978 18.0813 20.474 18.9396 20.0712 19.6776C19.6684 20.4155 19.0134 20.9838 18.226 21.2785C17.4386 21.5732 16.5715 21.5747 15.7831 21.2826C14.9947 20.9905 14.3379 20.4243 13.9326 19.6877C13.5273 18.9511 13.4007 18.0933 13.576 17.271Z"
      fill="#716E79"
    />
  </svg>
);

const ExpandIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.66667 1.99963V3.33297H3.33333V12.6663H12.6667V9.33297H14V13.333C14 13.5098 13.9298 13.6793 13.8047 13.8044C13.6797 13.9294 13.5101 13.9996 13.3333 13.9996H2.66667C2.48986 13.9996 2.32029 13.9294 2.19526 13.8044C2.07024 13.6793 2 13.5098 2 13.333V2.6663C2 2.48949 2.07024 2.31992 2.19526 2.1949C2.32029 2.06987 2.48986 1.99963 2.66667 1.99963H6.66667ZM11.724 3.33297H8.66667V1.99963H14V7.33297H12.6667V4.27563L8 8.9423L7.05733 7.99963L11.724 3.33297Z"
      fill="#2D8B93"
    />
  </svg>
);

const LeftArrowIcon = () => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.828 7.00001L7.778 2.05001L6.364 0.636014L5.56359e-07 7.00001L6.364 13.364L7.778 11.95L2.828 7.00001Z"
      fill="white"
    />
  </svg>
);

const RightArrowIcon = () => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.172 6.99999L0.222001 11.95L1.636 13.364L8 6.99999L1.636 0.635987L0.222 2.04999L5.172 6.99999Z"
      fill="white"
    />
  </svg>
);

const UpArrowIcon = () => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.069 7.25859L6.34667 0.748319C6.17524 0.512605 5.82435 0.512605 5.65426 0.748319L0.930597 7.25859C0.918972 7.2746 0.912009 7.29352 0.910478 7.31324C0.908946 7.33297 0.912908 7.35274 0.921922 7.37035C0.930937 7.38796 0.944653 7.40273 0.96155 7.41303C0.978447 7.42333 0.997864 7.42874 1.01765 7.42868H2.02211C2.09042 7.42868 2.1547 7.39519 2.19488 7.34028L5.99979 2.09564L9.8047 7.34028C9.84488 7.39519 9.90917 7.42868 9.97747 7.42868H10.9819C11.069 7.42868 11.1199 7.32957 11.069 7.25859Z"
      fill="black"
    />
  </svg>
);

const DownArrowIcon = () => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9818 0.571533H9.97729C9.90899 0.571533 9.8447 0.605015 9.80452 0.659926L5.99961 5.90457L2.1947 0.659926C2.15452 0.605015 2.09024 0.571533 2.02193 0.571533H1.01747C0.930415 0.571533 0.879522 0.670641 0.930415 0.741623L5.65274 7.25189C5.82417 7.48761 6.17506 7.48761 6.34515 7.25189L11.0675 0.741623C11.1197 0.670641 11.0688 0.571533 10.9818 0.571533Z"
      fill="black"
    />
  </svg>
);

const DownArrowIconColored = () => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9822 0.0712891H9.97778C9.90948 0.0712891 9.84519 0.104771 9.80501 0.159682L6.0001 5.40433L2.19519 0.159682C2.15501 0.104771 2.09072 0.0712891 2.02242 0.0712891H1.01796C0.930903 0.0712891 0.880011 0.170396 0.930903 0.241379L5.65323 6.75165C5.82465 6.98736 6.17555 6.98736 6.34564 6.75165L11.068 0.241379C11.1202 0.170396 11.0693 0.0712891 10.9822 0.0712891Z"
      fill="#27A6A4"
    />
  </svg>
);

const UpArrowIconColored = () => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.069 7.25859L6.34667 0.748319C6.17524 0.512605 5.82435 0.512605 5.65426 0.748319L0.930597 7.25859C0.918972 7.2746 0.912009 7.29352 0.910478 7.31324C0.908946 7.33297 0.912908 7.35274 0.921922 7.37035C0.930937 7.38796 0.944653 7.40273 0.96155 7.41303C0.978447 7.42333 0.997864 7.42874 1.01765 7.42868H2.02211C2.09042 7.42868 2.1547 7.39519 2.19488 7.34028L5.99979 2.09564L9.8047 7.34028C9.84488 7.39519 9.90917 7.42868 9.97747 7.42868H10.9819C11.069 7.42868 11.1199 7.32957 11.069 7.25859Z"
      fill="#27A6A4"
    />
  </svg>
);

const FilterIcon = () => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M7 12H11V10H7V12ZM0 0V2H18V0H0ZM3 7H15V5H3V7Z" fill="#454250" />
  </svg>
);

const DropDownIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.44958 12.5304L14.7371 4.48036C14.7536 4.45932 14.7639 4.43404 14.7668 4.40742C14.7696 4.3808 14.7649 4.35392 14.7531 4.32987C14.7414 4.30581 14.7231 4.28556 14.7004 4.27143C14.6776 4.2573 14.6514 4.24987 14.6246 4.25L13.2442 4.25C13.1567 4.25 13.0728 4.29107 13.0192 4.35893L7.99958 10.7875L2.97994 4.35893C2.92637 4.28929 2.84244 4.25 2.75494 4.25L1.37458 4.25C1.25494 4.25 1.18887 4.3875 1.26208 4.48036L7.54958 12.5304C7.60295 12.5988 7.67122 12.6541 7.7492 12.6922C7.82718 12.7303 7.91281 12.7501 7.99958 12.7501C8.08636 12.7501 8.17199 12.7303 8.24996 12.6922C8.32794 12.6541 8.39621 12.5988 8.44958 12.5304Z"
      fill="#454250"
    />
  </svg>
);

const AddToComparisionIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.50044 1V1.639L9.00044 2.473L10.8164 1.868L11.1329 2.816L9.61694 3.3215L11.1649 7.5775C10.6189 8.146 9.85044 8.5 9.00044 8.5C8.14994 8.5 7.38194 8.146 6.83594 7.5775L8.38294 3.3215L6.50044 2.6935V9.5H8.50044V10.5H3.50044V9.5H5.50044V2.6935L3.61644 3.3215L5.16444 7.5775C4.61894 8.146 3.85044 8.5 3.00044 8.5C2.14994 8.5 1.38194 8.146 0.835938 7.5775L2.38294 3.3215L0.867938 2.8165L1.18444 1.8675L3.00044 2.4725L5.50044 1.639V1H6.50044ZM9.00044 4.5515L8.02144 7.2445C8.31494 7.41 8.64994 7.5 9.00044 7.5C9.35044 7.5 9.68544 7.41 9.97944 7.245L9.00044 4.551V4.5515ZM3.00044 4.5515L2.02144 7.2445C2.31494 7.41 2.64994 7.5 3.00044 7.5C3.35044 7.5 3.68544 7.41 3.97944 7.245L3.00044 4.551V4.5515Z"
      className="ant-dropdown-menu-item"
    />
  </svg>
);

const RemoveFromListIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.5 2H11V3H10V10.5C10 10.6326 9.94732 10.7598 9.85355 10.8536C9.75979 10.9473 9.63261 11 9.5 11H2.5C2.36739 11 2.24021 10.9473 2.14645 10.8536C2.05268 10.7598 2 10.6326 2 10.5V3H1V2H3.5V1H8.5V2ZM4.5 4.5V8.5H5.5V4.5H4.5ZM6.5 4.5V8.5H7.5V4.5H6.5Z"
      className="ant-dropdown-menu-item"
    />
  </svg>
);
const DrugInfo = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 0.875C3.61758 0.875 0.875 3.61758 0.875 7C0.875 10.3824 3.61758 13.125 7 13.125C10.3824 13.125 13.125 10.3824 13.125 7C13.125 3.61758 10.3824 0.875 7 0.875ZM7 12.0859C4.1918 12.0859 1.91406 9.8082 1.91406 7C1.91406 4.1918 4.1918 1.91406 7 1.91406C9.8082 1.91406 12.0859 4.1918 12.0859 7C12.0859 9.8082 9.8082 12.0859 7 12.0859Z"
      fill="#1A1628"></path>
    <path
      d="M6.34354 4.59375C6.34354 4.7678 6.41268 4.93472 6.53575 5.05779C6.65882 5.18086 6.82574 5.25 6.99979 5.25C7.17383 5.25 7.34075 5.18086 7.46382 5.05779C7.5869 4.93472 7.65604 4.7678 7.65604 4.59375C7.65604 4.4197 7.5869 4.25278 7.46382 4.12971C7.34075 4.00664 7.17383 3.9375 6.99979 3.9375C6.82574 3.9375 6.65882 4.00664 6.53575 4.12971C6.41268 4.25278 6.34354 4.4197 6.34354 4.59375ZM7.32791 6.125H6.67166C6.61151 6.125 6.56229 6.17422 6.56229 6.23438V9.95312C6.56229 10.0133 6.61151 10.0625 6.67166 10.0625H7.32791C7.38807 10.0625 7.43729 10.0133 7.43729 9.95312V6.23438C7.43729 6.17422 7.38807 6.125 7.32791 6.125Z"
      fill="#1A1628"></path>
  </svg>
);

const FacetSearchIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5116 7.61472H9.14102V4.92275C9.14102 4.83436 9.06869 4.76204 8.9803 4.76204H7.77494C7.68655 4.76204 7.61423 4.83436 7.61423 4.92275V7.61472H5.24369C5.1553 7.61472 5.08298 7.68704 5.08298 7.77543V8.98079C5.08298 9.06918 5.1553 9.1415 5.24369 9.1415H7.61423V11.8335C7.61423 11.9219 7.68655 11.9942 7.77494 11.9942H8.9803C9.06869 11.9942 9.14102 11.9219 9.14102 11.8335V9.1415H11.5116C11.5999 9.1415 11.6723 9.06918 11.6723 8.98079V7.77543C11.6723 7.68704 11.5999 7.61472 11.5116 7.61472ZM17.2169 16.1326L14.2839 13.1995C16.7368 10.2082 16.566 5.77655 13.7616 2.97409C10.7883 -0.00113004 5.95887 -0.00113004 2.9736 2.97409C-0.00161833 5.95936 -0.00161833 10.7888 2.9736 13.762C5.77606 16.5665 10.2078 16.7373 13.1991 14.2844L16.1321 17.2174C16.1964 17.2736 16.2988 17.2736 16.3531 17.2174L17.2169 16.3536C17.2732 16.2993 17.2732 16.1969 17.2169 16.1326ZM12.6968 12.6973C10.3102 15.0819 6.44503 15.0819 4.05843 12.6973C1.67383 10.3107 1.67383 6.44552 4.05843 4.05891C6.44503 1.67432 10.3102 1.67432 12.6968 4.05891C15.0814 6.44552 15.0814 10.3107 12.6968 12.6973Z"
      fill="#454250"
    />
  </svg>
);

const CloseIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.9257 7.99916L13.6132 2.41166C13.6918 2.31881 13.6257 2.17773 13.5043 2.17773H12.0793C11.9953 2.17773 11.915 2.21523 11.8596 2.27952L7.99356 6.88845L4.12749 2.27952C4.07392 2.21523 3.99356 2.17773 3.90784 2.17773H2.48284C2.36142 2.17773 2.29534 2.31881 2.37392 2.41166L7.06142 7.99916L2.37392 13.5867C2.35631 13.6074 2.34502 13.6327 2.34138 13.6596C2.33774 13.6865 2.3419 13.7139 2.35337 13.7386C2.36484 13.7632 2.38313 13.784 2.40608 13.7985C2.42903 13.8131 2.45568 13.8207 2.48284 13.8206H3.90784C3.99177 13.8206 4.07213 13.7831 4.12749 13.7188L7.99356 9.10988L11.8596 13.7188C11.9132 13.7831 11.9936 13.8206 12.0793 13.8206H13.5043C13.6257 13.8206 13.6918 13.6795 13.6132 13.5867L8.9257 7.99916Z"
      fill="black"
      fill-opacity="0.45"
    />
  </svg>
);

const searchIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.99 15.8837L11.7728 10.6665C12.5824 9.61986 13.0204 8.34018 13.0204 6.99419C13.0204 5.38303 12.3916 3.87232 11.2545 2.73326C10.1175 1.59419 8.60273 0.967407 6.99358 0.967407C5.38443 0.967407 3.8697 1.5962 2.73264 2.73326C1.59358 3.87031 0.966797 5.38303 0.966797 6.99419C0.966797 8.60334 1.59559 10.1181 2.73264 11.2551C3.8697 12.3942 5.38242 13.021 6.99358 13.021C8.33956 13.021 9.61724 12.583 10.6639 11.7754L15.8811 16.9906C15.8964 17.0059 15.9145 17.0181 15.9345 17.0264C15.9545 17.0346 15.976 17.0389 15.9976 17.0389C16.0192 17.0389 16.0407 17.0346 16.0607 17.0264C16.0807 17.0181 16.0988 17.0059 16.1141 16.9906L16.99 16.1167C17.0053 16.1014 17.0175 16.0833 17.0257 16.0633C17.034 16.0433 17.0383 16.0219 17.0383 16.0002C17.0383 15.9786 17.034 15.9571 17.0257 15.9372C17.0175 15.9172 17.0053 15.899 16.99 15.8837ZM10.1757 10.1763C9.32394 11.0261 8.19492 11.4942 6.99358 11.4942C5.79224 11.4942 4.66323 11.0261 3.81144 10.1763C2.96166 9.32455 2.49358 8.19553 2.49358 6.99419C2.49358 5.79285 2.96166 4.66183 3.81144 3.81205C4.66323 2.96227 5.79224 2.49419 6.99358 2.49419C8.19492 2.49419 9.32595 2.96026 10.1757 3.81205C11.0255 4.66384 11.4936 5.79285 11.4936 6.99419C11.4936 8.19553 11.0255 9.32656 10.1757 10.1763Z"
      fill="white"
    />
  </svg>
);

export {
  EicIcon,
  EvidenceSuiteIcon,
  HomeIcon,
  ZaidynLogo,
  LibraryIcon,
  ExploreIcon,
  SurveyQuestionsIcon,
  BespokeInsightIcon,
  SideNavQuestionMarkIcon,
  HeaderQuestionMarkIcon,
  UserIcon,
  WindowIcon,
  CopyIcon,
  ShareIcon,
  TableFilterIcon,
  EditIcon,
  DownloadIcon,
  DeleteIcon,
  ExpandIcon,
  FilterIcon,
  DownArrowIcon,
  UpArrowIcon,
  LeftArrowIcon,
  DeleteSmallIcon,
  RightArrowIcon,
  DropDownIcon,
  AddToComparisionIcon,
  RemoveFromListIcon,
  DrugInfo,
  FacetSearchIcon,
  DownArrowIconColored,
  UpArrowIconColored,
  CloseIcon,
  searchIcon,
};
